import Vue from 'vue';
import VueRouter from 'vue-router';
import paths from './paths';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    // let toPath = to.fullPath.split('/');
    // if (toPath[1] == 'news' || toPath[1] == 'events') {
    //   return new Promise((resolve, reject) => {
    //     setTimeout(() => {
    //       resolve({ x: 0, y: 200 });
    //     }, 1000);
    //   });
    // }
    return { x: 0, y: 0 };
  },
  routes: paths
});

export default router;
